import { getValue } from '../../common/SessionStorage';

export const getIsNavbarCollapsed = () =>
  !!getValue(`["navCollapsed","pinnedPath"]`)?.navCollapsed;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/Layout/LayoutSessionStorage.js